module.exports = __webpack_public_path__ + "img/SKLB-Dispositivos.af3dd355.png";